import colors from '../tokens/colors';

export const checkboxGetolo = {
  base: {
    width: 24,
    height: 24,
    border: {
      color: colors.PROFESSIONAL_LIGHT_BLUE,
      width: 1,
      radius: 2,
    },
    labelSpacing: '0.5rem',
    rippleColor: colors.PROFESSIONAL_LIGHT_BLUE,
    typography: 'body',
  },
  states: {
    hover: {},
    checked: {
      check: {
        color: colors.PROFESSIONAL_BLUE,
        width: 2,
      },
      border: {
        color: colors.PROFESSIONAL_BLUE,
      },
      rippleColor: colors.PROFESSIONAL_BLUE,
    },
    focusVisible: {
      outline: `3px solid ${colors.PROFESSIONAL_BLUE}`,
      outlineOffset: 1.5,
    },
    disabled: {
      borderColor: colors.GRAY,
    },
  },
};

export const checkboxDaDirekt = {
  base: {
    width: 24,
    height: 24,
    border: {
      color: colors.DA_DIREKT_BORDER_LINES,
      width: 2,
      radius: 2,
    },
    labelSpacing: '0.5rem',
    rippleColor: colors.DA_DIREKT_BORDER_LINES,
    typography: 'body',
  },
  states: {
    hover: {},
    checked: {
      check: {
        color: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
        width: 2,
      },
      border: {
        color: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
      },
      rippleColor: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    },
    focusVisible: {
      outline: `2px solid ${colors.DA_DIREKT_VISUAL_BRAND_ORANGE}`,
      outlineOffset: 2,
    },
    disabled: {
      borderColor: null,
    },
  },
};

export const checkboxDaKaufland = {
  base: {
    width: 22,
    height: 22,
    border: {
      color: colors.DA_KAUFLAND_GRAY_2,
      width: 2,
      radius: 0,
    },
    labelSpacing: '0.75rem',
    rippleColor: 'transparent',
    typography: 'p4',
  },
  states: {
    hover: {},
    checked: {
      check: {
        color: colors.DA_KAUFLAND_BLACK,
        width: 2,
      },
      border: {
        color: colors.DA_KAUFLAND_GRAY_2,
      },
      rippleColor: 'transparent',
    },
    focusVisible: {
      outline: `2px solid ${colors.DA_KAUFLAND_RED}`,
      outlineOffset: 2,
    },
    disabled: {
      borderColor: null,
    },
  },
};

export const checkboxFressnapf = {
  base: {
    width: 24,
    height: 24,
    border: {
      color: colors.FRESSNAPF_PRIMARY_HOVER,
      width: 2,
      radius: 2,
    },
    labelSpacing: '0.5rem',
    rippleColor: colors.FRESSNAPF_PRIMARY_HOVER,
    typography: 'body',
  },
  states: {
    hover: {
      fill: colors.FRESSNAPF_HOVER,
    },
    checked: {
      check: {
        color: colors.FRESSNAPF_PRIMARY_HOVER,
        width: 2,
      },
      border: {
        color: colors.FRESSNAPF_PRIMARY_HOVER,
      },
      rippleColor: colors.FRESSNAPF_PRIMARY_HOVER,
    },
    focusVisible: {
      outline: 'none',
      outlineOffset: 0,
    },
    disabled: {
      borderColor: null,
    },
  },
};
